<template>
    <stage :content="content"/>
</template>

<script>
// @ is an alias to /src
import stageContent from '@/data/team.js'
import stage from '@/components/stage.vue'

export default {
  name: 'Team',
  components: {
    stage
  },
  data () {
    return {
      content: stageContent
    }
  }
}
</script>
